"use client";

import { useState, useEffect } from 'react';
import styles from './_page-references.module.scss';

export default function HcpPageReferences({references}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  return (
    <section className={`hcp-references ${styles.container}`}>
      <div className="container--small">
        {references && <div className={styles.references}>
          <p className={styles.header}>REFERENCE{references.length > 1 && `S`}</p>
          {mounted && <ul>
            {references?.map((reference, i) => (
              <li key={`ref_key_${i}`}>
                {reference}
              </li>
            ))}
          </ul>}
        </div>}
      </div>
    </section>
  );
}